import * as t from 'io-ts';
import { isUndefined } from 'lodash-es';

import type { CheckBoxDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';

export interface ApplyFilterToUpstreamHierarchyLevelsDefinition extends CheckBoxDefinition {
    key: 'APPLY_FILTER_TO_UPSTREAM_HIERARCHY_LEVELS';
}

const definition: ApplyFilterToUpstreamHierarchyLevelsDefinition = {
    key: 'APPLY_FILTER_TO_UPSTREAM_HIERARCHY_LEVELS',
    type: 'CheckBox',
    label: 'Apply filter to upstream levels within hierarchy',
    value: true,
    scope: 'designer',
};

const specSettingsInterface = createSpecSettingsInterface(definition, t.boolean);

export const codec = specSettingsInterface.input;

/**
 * Setting which intention is controlling the filtering of upstream selectors within the hierarchy.
 * Can be used to add a `effect` property on a filter element of the filter value array signifying the element should not lead to parent selection.
 *
 * Introduced in 3167: Hierarchy filtering - don't autoselect upstream
 */
export const ApplyFilterToUpstreamHierarchyLevelsDefinition = define({
    key: 'APPLY_FILTER_TO_UPSTREAM_HIERARCHY_LEVELS',
    label: 'applyFilterToUpstreamHierarchyLevels',
    definition,
    fromSetting: (settings, _, view) => {
        return (
            specSettingsInterface.extractValue(settings.applyFilterToUpstreamHierarchyLevels) ??
            // since we want the setting to be present even if not defined on the config,
            // we return the default value (`definition.value`) - unless we are calculating
            // the setting for particular view (returning default value would overwrite the default, which is not what we want)
            (view ? undefined : definition.value)
        );
    },
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings =>
        isUndefined(settings.applyFilterToUpstreamHierarchyLevels)
            ? // even if setting is not defined, we still want it to be available
              definition
            : specSettingsInterface.createDefinitionWithSettings(
                  settings.applyFilterToUpstreamHierarchyLevels,
              ),
});
